// Keep setup state while closed; inert prevents focus entering collapsing content.
export function InstallDisclosure({open, id, labelledBy, className = '', children}) {
  return <div id={id} className={`pabs-install-disclosure ${className}`} data-open={open}
    role={labelledBy ? 'region' : undefined} aria-labelledby={labelledBy}
    aria-hidden={open ? undefined : true} {...(!open ? {inert: ''} : {})}>
    <div className="pabs-install-disclosure-clip">{children}</div>
  </div>;
}
